import React, { useEffect, useState } from "react";
import { getobj, postobj } from "../apicall/apicall";
import { TextField, MenuItem, Button, Box, Card } from "@mui/material";
import { buttonStyle } from "../style/style";
import { NotificationManager } from "react-notifications";
import NotificationContainer from "react-notifications/lib/NotificationContainer";

export default function AddDistributor(props) {
  const [org_list, setorg_list] = useState();
  const [data, set_data] = useState({
    id: props.id,
    org_id: "",
  });
  const [loaded, setloaded] = useState(true);

  useEffect(() => {
    const url = process.env.REACT_APP_ZEWA_URL + "distributor/org-list/";
    const res = getobj(url);
    res.then(function (res) {
      setorg_list(res.results);
      setloaded(false);
    });
  }, []);

  const handleClick = () => {
    if (data["org_id"] !== "") {
      const url = process.env.REACT_APP_ZEWA_URL + "distributor/add-org/";
      const res = postobj(url, data);
      res
        .then((res) => {
          if (res.status === 200) {
            return res;
          }
          throw new Error(res);
        })
        .then((res) => {
          //console.log(res);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message);
          props.setrefresh(!props.refresh);
          props.setopen(false);
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Something went wrong");
        });
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Please Select a organization");
    }
  };

  return (
    <div style={{ padding: "0.625rem", overflow: "hidden" }}>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <div>
          {org_list.length > 0 ? (
            <Box>
              <TextField
                select
                name="user_list"
                id="deviceName"
                sx={{ width: "100%", maxWidth: "500px" }}
                variant="outlined"
                label="Organization list"
                value={data.org_id}
                onChange={(e) => {
                  set_data({
                    ...data,
                    org_id: e.target.value,
                  });
                }}
              >
                {org_list.map((i) => {
                  return <MenuItem value={i.id}>{i.company_name}</MenuItem>;
                })}
              </TextField>
              <Button
                color="primary"
                variant="contained"
                className="form__custom-button"
                type="submit"
                sx={buttonStyle}
                onClick={() => {
                  handleClick();
                }}
              >
                Add
              </Button>
              <Button
                color="error"
                variant="contained"
                className="form__custom-button"
                type="submit"
                sx={buttonStyle}
                onClick={() => {
                  props.setopen(false);
                }}
              >
                Cancel
              </Button>
            </Box>
          ) : (
            <Card>No Organization available</Card>
          )}
        </div>
      )}
      <NotificationContainer />
    </div>
  );
}
